enum ActionTypes {
  HISTORY_SET_PAGE = 'MENTOR_MENTEE_HISTORY_SET_PAGE',
  HISTORY_SET_SEARCH = 'MENTOR_MENTEE_HISTORY_SET_SEARCH',
  HISTORY_SET_ORDER = 'MENTOR_MENTEE_HISTORY_SET_ORDER',
}

export default ActionTypes;
